import React from 'react';
import { Link } from 'react-router-dom';
import CoachingInsightCard from '../components/insights/CoachingInsightCard';

// Insights does exactly two things: tell you what to focus on (the coach) and
// let you test one change (experiments). Progress/measurement lives on the You
// page — the single source for "where am I and where am I heading" — so it
// deliberately isn't duplicated here.

const InsightsPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-10">
      <div className="space-y-6">
        {/* Experiments launcher — the n-of-1 "try one change" surface. */}
        <Link
          to="/experiments"
          className="block rounded-xl border border-surface-border dark:border-surface-dark-border
                     bg-surface-card dark:bg-surface-dark-card p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-base font-semibold text-gray-900 dark:text-white">
                Run an experiment
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-0.5">
                Change one thing for a couple of weeks and see honestly what moved.
              </p>
            </div>
            <span className="text-primary-600 dark:text-primary-400 text-xl shrink-0" aria-hidden>→</span>
          </div>
        </Link>

        {/* AI Health Coach — the prioritized focus list. */}
        <CoachingInsightCard />
      </div>
    </div>
  );
};

export default InsightsPage;
